export default __webpack_public_path__ + "static/media/why-index-sec-left.bfc7318a.png";